import Vue from "vue";
import Router from "vue-router";
import WidgetHome from "../views/WidgetHome";
import Chat from "../views/Chat"
import Help from "../views/Help";
import ArticleRenderer from "../components/ArticleRenderer";

Vue.use(Router);

const routes = [
  {
    path: "/home",
    name: "Home",
    component: WidgetHome,
    props: route => ({
      chatTabProps: route.query,
    })
  },
  {
    path: "/chat",
    name: "Chat",
    component: Chat,
    props: route => ({
      chatTabProps: route.query,
    })
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
  },
  {
    path: "/help/article/:id",
    name: "ArticleRenderer",
    component: ArticleRenderer,
    props: route => ({ id: route.params.id, article: JSON.parse(route.query.article) })
  },
  {
    path: "*",
    redirect: "/home"
  }
];

export default new Router({
  mode: "history",
  routes
});
